export default __webpack_public_path__ + "static/media/acceptable-photo.32da4fe0.png";